import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// 导入翻译文本的 .json 文件
import EN from './en.json';
import zhCN from './zh.json';

const messages = {
  'en': EN,
  'zh-CN': zhCN,
};

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
});

export default i18n;
